import React from 'react';
import useEventBookingSession from 'features/Events/hooks/useEventBookingSession';
import useLimitedTimeStatus from 'hooks/useLimitedTimeStatus';
import LimitedTimeMessage from 'components/atoms/LimitedTime/LimitedTimeMessage';
import { LimitedTimeContainer } from 'components/atoms/LimitedTime';

export const EventLimitedTime: React.FC = () => {
  const { listing } = useEventBookingSession();

  const limitedTime = useLimitedTimeStatus(
    listing?.limitedTime?.ticketSalesOpenAt,
    listing?.limitedTime?.ticketSalesCloseAt,
  );

  if (!listing || !limitedTime?.static) {
    return null;
  }

  return (
    <LimitedTimeContainer>
      <LimitedTimeMessage
        label={limitedTime.static.full}
        highlightPart={limitedTime.static.highlight}
      />
    </LimitedTimeContainer>
  );
};
